import { render, staticRenderFns } from "./color.vue?vue&type=template&id=3ea0d74a&scoped=true"
import script from "./color.vue?vue&type=script&lang=ts"
export * from "./color.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea0d74a",
  null
  
)

export default component.exports